{
  "en": {
    "installment_term": {
      "actions": {
        "addUnits": "Units",
        "add_fraction": "Add fraction",
        "create": "Create",
        "create_price_term": "New rule",
        "delete": "Delete",
        "deleteMultiple": "Delete...",
        "delete_cancel": "Cancel",
        "edit": "Edit",
        "newInstallment": "Installment term",
        "publish_customer": "Publish for customer",
        "selectAll": "Select all {total} installments",
        "selectOne": "Select one installment",
        "take": "Take"
      },
      "attributes": {
        "description": "Description",
        "installments_count": "{count} installment | {count} installments",
        "name": "Title"
      },
      "labels": {
        "addAllSurcharges": "All current upgrades",
        "addAllUnitsPrices": "All unit prices",
        "allUnitsAssigned": "All units assigned",
        "amount": "Installment amount",
        "balanceFractionTypes": "Balance Fraction Types",
        "balanceTotal": "Balance Total",
        "containsSurcharges": "Contains upgrades",
        "create_decision_first": "This option will become available once you've created a decision.",
        "deleteInstallmentTerm": "Delete installment term",
        "description": "Description",
        "documents": "Documents",
        "duplicate_price_type": "A fraction with this price type already exists.",
        "editInstallmentTerm": "Edit installment term",
        "edit_description": "Edit description",
        "fixed": "Fixed",
        "fixedAmount": "Fixed amount of",
        "for": "for",
        "forEachUnit": "of each unit",
        "fraction_types": {
          "absolute": "Fixed Amount",
          "relative": "Percentage"
        },
        "goToAmounts": "Select amounts",
        "installments": "Financials",
        "installmentsTitle": "Installment",
        "installments_all_projects": "Financials all projects",
        "invalidAmount": "Invalid amount",
        "list": "List",
        "name": "Installment Term #{count}",
        "noContainsSurcharges": "Does not contain upgrades",
        "noInstallmentsToPay": "No installments pending",
        "noUnitsClick": "No units yet, click here to add",
        "ofThe": "of the",
        "price_types": {
          "custom_amount": "Other",
          "price_value": "Total value",
          "price_value_construction": "Construction value",
          "price_value_construction_existing": "Costs of existing construction",
          "price_value_fees": "Architect/Engineering fees",
          "price_value_land": "Land value",
          "surcharge": "Upgrades",
          "unit": "Unit prices"
        },
        "projectUnitsTotal": "{project_name} has {units_count_max} units in total",
        "publish_now": "Publish now?",
        "rules": "Payment Rules",
        "rules_subtitle": "Define what percentage or amount to collect",
        "save_explainer": "Make this installment term visible for your customers? Or save and publish later?",
        "selectUnits": "Select units",
        "selected": "{selected} installment selected. | {selected} installments selected.",
        "shortcuts": "Shortcuts",
        "show_installment_terms_for": "Show installments for",
        "step1Info": "Add a description",
        "step2Subtitle": "Select your project to include all your units at once.",
        "step2Title": "Which units are related with this installment?",
        "surcharges": "Upgrades",
        "total": "Total",
        "totalFixed": "Total fixed",
        "totalPaid": "Total paid",
        "totalRequested": "Total invoiced",
        "totalSelected": "All {total} installments are selected.",
        "totalSurcharges": "Total upgrades",
        "totalUnpaid": "Total unpaid",
        "unitSelected": "No unit selected yet | One unit selected | {count} units selected",
        "units": "Units"
      },
      "navigation": {
        "backToInstallmentTerms": "Back to installments terms overview"
      },
      "placeholders": {
        "amount": "Selecionar um montante fixo ou uma percentagem do valor unitário ou das actualizações",
        "description": "E.g. 10% - After pooring the concrete slab on the first floor...",
        "due_date": "Set a date by which the installment has to be paid",
        "employees": {
          "new": {
            "subtitle": "Add installments and keep track of their status",
            "title": "Create a financial overview"
          }
        },
        "installmentTermFractionNotice": "The installment amounts can no longer be adjusted because some installments have already been delivered to the buyer",
        "name": "E.g. Installment Term #1, Installment Term - Upgrades",
        "summary": "Summary",
        "surcharge": "upgrade"
      },
      "toasts": {
        "bulk_create": "Installment successfully created | Installments successfully created",
        "bulk_delete": "Installment successfully deleted | Installments successfully deleted",
        "bulk_update": "Installment successfully updated | Installments successfully updated",
        "delete": "Installment successfully deleted",
        "update": "Installment successfully updated"
      },
      "validation": {
        "fixedFractionLabel": "{price_type} has already been combined with {fraction_type} in another existing installment. Only {fraction_type} is allowed to keep consistency.",
        "maxLengthName": "Name is too long",
        "needDescription": "Description required",
        "needInstallmentTermFraction": "One term price is required",
        "needName": "Name required",
        "needUniquePricesTypes": "Rules cannot have the same price types within an installment term",
        "needValidTerm": "Amount cannot be 0 and the price type must exist",
        "selectInstallmentTerm": "Select at least 1 installment",
        "selectUnit": "Select at least 1 unit"
      }
    }
  }
}
